/* eslint-disable no-shadow */
const initialState = {
  termsOfServiceAccepted: false,
  filterDealershipsIds: [],
  selectedVehicles: [], // used to populate for inventory mfe flow for guaranteed sale in web host
  appliedFilters: [],
  selectedViewType: {},
  launchedVehicles: {},
};

const state = { ...initialState };

const mutations = {
  setInventoryState(state, receivedMfeState) {
    Object.assign(state, receivedMfeState);
  },
  resetInventoryState(state) {
    Object.assign(state, initialState);
  },
  setSelectedVehicles(state, vehicles) {
    state.selectedVehicles = vehicles;
  },
  setLaunchedVehicles(state, launchedVehicles) {
    state.launchedVehicles = launchedVehicles;
  },
};

const actions = {
  // triggered from inventory mfe vuex watcher to keep host vuex state in sync
  updateFromMfe({ commit }, receivedMfeState) {
    commit('setInventoryState', receivedMfeState);
  },
  reset({ commit }) {
    commit('resetInventoryState');
  },
  // Mirror the myInventoryRemote action interface so MyAcvGuaranteedSale can swap
  // module names without additional changes.
  setSelectedVehiclesData({ commit }, vehicles) {
    commit('setSelectedVehicles', vehicles);
  },
  // Stores launched vehicles data so MyInventoryMfeInterface can pass it to the
  // WC element as pendingLaunchedVehicles before appendChild, allowing
  // MyInventory.vue's mounted() hook to show the snackbar from the isolated store.
  setLaunchedVehiclesData({ commit }, launchedVehicles) {
    commit('setLaunchedVehicles', launchedVehicles);
  },
};

const getters = {
  // Mirrors the myInventoryRemote getter interface so host components can swap
  // between 'myInventoryRemote' and 'inventoryMfe' by module name alone.
  termsOfServiceAccepted: (state) => state.termsOfServiceAccepted === true,
  filterDealershipsIds: (state) => state.filterDealershipsIds,
  selectedVehicles: (state) => state.selectedVehicles,
  appliedFilters: (state) => state.appliedFilters,
  selectedViewType: (state) => state.selectedViewType,
  launchedVehicles: (state) => state.launchedVehicles,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
